/* eslint-disable no-param-reassign */
import { Reducer } from 'redux';
import produce from 'immer';
import { IPaymentState, PaymentTypes } from './types';

const INITIAL_STATE: IPaymentState = {
  data: [],
  disabled: false,
  printing: false,
  loading: false,
  error: false,
};

const payment: Reducer<IPaymentState> = (state = INITIAL_STATE, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case PaymentTypes.LOAD_PAYMENT_REQUEST: {
        draft.loading = true;
        break;
      }
      case PaymentTypes.LOAD_PAYMENT_SUCCESS: {
        draft.data = action.payload.data;
        draft.disabled = action.payload.data.length === 0;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case PaymentTypes.LOAD_PAYMENT_FAILURE: {
        draft.data = [];
        draft.disabled = false;
        draft.loading = false;
        draft.error = true;
        break;
      }
      case PaymentTypes.PRINT_PAYMENT_REQUEST: {
        draft.printing = true;
        break;
      }
      case PaymentTypes.PRINT_PAYMENT_SUCCESS: {
        draft.printing = false;
        draft.error = false;
        break;
      }
      case PaymentTypes.PRINT_PAYMENT_FAILURE: {
        draft.printing = false;
        break;
      }
      default:
        break;
    }
  });
};

export default payment;
